<template>
  <div
    class="magic-wand-examples-panel"
    :style="panelStyle"
    aria-live="polite"
    :aria-label="panelAriaLabel"
  >
    <div class="magic-wand-examples-header">
      <div class="magic-wand-examples-header-left">
        <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="18" height="18">
        <span class="magic-wand-examples-title">Examples</span>
      </div>
      <button
        type="button"
        class="magic-wand-close-btn"
        aria-label="Close examples"
        @click="$emit('close')"
      >&times;</button>
    </div>
    <p v-if="fieldLabel" class="magic-wand-examples-subtitle">
      For: <strong>{{ fieldLabel }}</strong>
    </p>
    <p class="magic-wand-examples-hint">Browse examples while you write. Your text is never replaced unless you choose one.</p>
    <div v-if="loading" class="magic-wand-examples-loading" role="status">Loading examples...</div>
    <div v-else-if="examples.length === 0" class="magic-wand-examples-empty">
      No examples available for this field.
    </div>
    <div v-else class="magic-wand-examples-single">
      <div class="magic-wand-example-card">
        <p class="magic-wand-example-text" aria-live="polite">{{ currentExample }}</p>
      </div>
      <p v-if="confirming" class="magic-wand-confirm-text" role="alert">This will replace your current text.</p>
      <div class="magic-wand-example-footer">
        <div class="magic-wand-example-action">
          <template v-if="confirming">
            <button
              type="button"
              class="magic-wand-use-btn magic-wand-confirm-yes"
              @click="confirmUse"
            >
              Yes, use it
            </button>
            <button
              type="button"
              class="magic-wand-use-btn magic-wand-confirm-cancel"
              @click="cancelUse"
            >
              Cancel
            </button>
          </template>
          <button
            v-else
            type="button"
            class="magic-wand-use-btn"
            @click="requestUse"
          >
            Use this example
          </button>
        </div>
        <div v-if="examples.length > 1" class="magic-wand-example-nav">
          <button
            type="button"
            class="magic-wand-nav-btn"
            aria-label="Previous example"
            :disabled="currentIndex === 0"
            @click="prev"
          >&lsaquo;</button>
          <span class="magic-wand-nav-count">{{ currentIndex + 1 }} / {{ examples.length }}</span>
          <button
            type="button"
            class="magic-wand-nav-btn"
            aria-label="Next example"
            :disabled="currentIndex === examples.length - 1"
            @click="next"
          >&rsaquo;</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    examples: {
      type: Array,
      default: () => []
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    magicWandIcon: {
      type: String,
      required: true
    },
    accentColor: {
      type: String,
      default: '#D13525'
    },
    fieldHasText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: 0,
      confirming: false
    };
  },
  watch: {
    // Reset navigation + confirmation when switching fields or reloading examples.
    fieldLabel() {
      this.resetState();
    },
    examples() {
      this.resetState();
    }
  },
  computed: {
    currentExample() {
      return this.examples[this.currentIndex] || '';
    },
    panelAriaLabel() {
      return this.fieldLabel
        ? `Example suggestions for ${this.fieldLabel}`
        : 'Example suggestions';
    },
    panelStyle() {
      return {
        '--magic-wand-accent': this.accentColor
      };
    }
  },
  methods: {
    resetState() {
      this.currentIndex = 0;
      this.confirming = false;
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.confirming = false;
      }
    },
    next() {
      if (this.currentIndex < this.examples.length - 1) {
        this.currentIndex += 1;
        this.confirming = false;
      }
    },
    requestUse() {
      // No existing text -> insert directly. Otherwise ask for inline confirmation.
      if (this.fieldHasText) {
        this.confirming = true;
      } else {
        this.$emit('use-example', this.currentExample);
      }
    },
    confirmUse() {
      this.confirming = false;
      this.$emit('use-example', this.currentExample);
    },
    cancelUse() {
      this.confirming = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MagicWandExamplesPanel.vue